import { AppStoreBadge, PlayMarketBadge } from "@xola/icons";
import clsx from "clsx";
import React from "react";
import { FeatureRole } from "types";
import { isNativeTabletApp } from "../../helpers/browserHelper";
import { useSeller } from "../../hooks/useAccount";
import { useDevice } from "../../hooks/useSystemInfo";
import { useVisibility } from "../../hooks/useVisibility";
import { hasFeature } from "../../models/Seller";
import { OS } from "../../types/Device";
import { SecondaryButton } from "../Common/SecondaryButton";
import { getDownloadLink } from "./AppCalloutHelper";

export const AppCalloutBanner = () => {
    const seller = useSeller();
    const { data, isTablet, isMobile } = useDevice();

    const isLiveChatAvailable = hasFeature(seller, FeatureRole.XCHAT);

    const link = getDownloadLink(data);

    const [displayed, { hide }] = useVisibility(!!link);

    return displayed && !isNativeTabletApp() ? (
        <div
            className={clsx(
                "max-w-11/12 fixed right-0 bottom-0 z-50 m-4 flex flex-col rounded-lg bg-blue-lighter p-4 md:left-24 lg:w-10/12 xl:left-50",
                { "w-2/3": isLiveChatAvailable },
            )}
        >
            <div
                className={clsx(
                    "flex justify-between space-y-3",
                    { "flex-col": isMobile },
                    { "space-y-0": isTablet && isLiveChatAvailable },
                )}
            >
                <div className="flex space-x-2">
                    <div className={clsx("flex-col space-y-1", isTablet && "w-[90%]")}>
                        <h4 className="font-bold">Download Apps</h4>
                        {isTablet ? (
                            <div>
                                It looks like you’re using Xola from your tablet. For a better experience use the Xola
                                Tablet app
                            </div>
                        ) : (
                            <div className="flex-col space-y-2">
                                <div>
                                    It looks like you’re using Xola from your mobile phone. For a better experience, use
                                    the Xola Phone app – it’s designed specifically for mobile users.
                                </div>
                                <div> Download the app now!</div>
                            </div>
                        )}
                    </div>
                </div>
                <div
                    className={clsx(
                        "flex space-x-2",
                        { "items-center": isTablet && !isLiveChatAvailable },
                        { "justify-between": isMobile },
                    )}
                >
                    <a href={link} target="_blank" rel="noreferrer">
                        <span onClick={hide}>
                            {data.os.name === OS.ANDROID ? <PlayMarketBadge /> : <AppStoreBadge />}
                        </span>
                    </a>

                    <SecondaryButton size="small" color="secondary" onClick={hide}>
                        Dismiss
                    </SecondaryButton>
                </div>
            </div>
        </div>
    ) : null;
};
